import {
  ComplaintsDocument,
  UpdateComplaintCategoryDocument,
  UpdateComplaintCategoryMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateComplaintCategory = () => {
  const [executeMutation, { loading }] = useMutation(UpdateComplaintCategoryDocument, {
    extractorFn: (data: UpdateComplaintCategoryMutation) =>
      data.complaintsMutations.updateCategoryComplaintsComplaint,
  })

  const updateComplaintCategory = async (variables: {
    complaintId: number
    categoryId: number | null
  }) => {
    return await executeMutation({
      variables,
      refetchQueries: [ComplaintsDocument],
    })
  }

  return {
    updateComplaintCategory,
    loading,
  }
}
